export default __webpack_public_path__ + "static/media/6.5c13f342.jpeg";